Wee.fn.make('subjectForm', {
	init: function() {
		var selectedLink;

		if (localStorage.getItem('formSubmitted')) {
			$('ref:downloadForm').addClass('-submitted');
			$('ref:downloadForm').each(function(el) {
				$(el).attr('href', $(el).data('source'));
			});

			if (localStorage.getItem('selectedLink')) {
				var a = document.createElement('a');
				a.href = localStorage.getItem('selectedLink');
				a.download = localStorage.getItem('selectedLink');
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
				localStorage.removeItem('selectedLink');
			}
		}
		var results = [],
		rules = [
			[
				'.js-first-name',
				'required'
			],
			[
				'.js-last-name',
				'required'
			],
			[
				'.js-email',
				'required|email'
			],
			[
				'.js-primary-role',
				'required'
			]
		];

		Wee.events.on({
			'ref:downloadForm': {
				click: function(e) {
					selectedLink = $(e.target).data('source');

					if (! $(e.target).hasClass('-submitted')) {
						$('ref:subjectForm').show();
						e.preventDefault();
					}
				}
			},
			'ref:submissionForm': {
				submit: function(e) {
					results = Wee.validate.run(rules);

					$('.form-input-error').hide();
					$('.subject-form__input').removeClass('-has-error');
					$('.subject-form__select').removeClass('-has-error');

					if (! results.length) {
						localStorage.setItem('formSubmitted', 'true');
						localStorage.setItem('selectedLink', selectedLink);
						$('ref:subjectForm').hide();
					} else {
						for (var i = 0; i < results.length; i++) {
							var modifier = '-' + results[i][1] + '-error';

							$(results[i][0] + modifier).show();
							$(results[i][0]).addClass('-has-error');
						}
						e.preventDefault();
					}
				}
			},
			'ref:formClose': {
				click: function() {
					$('ref:subjectForm').hide();
				}
			}
		});
	}
});

Wee.subjectForm.init();